import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import mindImage from '../../public/b12/mind.svg';

type Props = {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
};

export default function Hero({
  title,
  subtitle,
  buttonText,
  buttonLink,
}: Props) {
  const { t } = useTranslation();

  return (
    <section className="bg-white">
      <div className="mx-auto flex max-w-7xl py-32  px-6">
        <div className="flex-[2]">
          <h1 className="text-r-5xl my-8 text-center font-bold leading-[3.5rem] lg:text-left">
            {title}
          </h1>
          <p className="text-r-2xl mb-8 text-center text-black lg:max-w-lg lg:text-left">
            {subtitle}
          </p>
          <div className="flex justify-center gap-4 lg:justify-start">
            <a
              href={buttonLink}
              className="btn-primary"
              target="_blank"
              rel="noreferrer noopener"
            >
              {buttonText}
            </a>
            <Link href="/contact">
              <a className="btn-secondary text-primary hover:text-white">
                {t('contact_us')}
              </a>
            </Link>
          </div>
        </div>
        <div className="hidden lg:flex">
          <div className="mt-4 -mr-12 flex-1">
            <Image
              src={mindImage}
              width="500"
              height="407"
              alt={t('b12_mind')}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}
